module.exports = __webpack_public_path__ + "img/20190418_154809_004.5f71c40a.jpg";